module.exports = __webpack_public_path__ + "media/10_swiftly.d5ceca98.mp3";